
/*
export function someGetter(state) {

  return state;
}
*/
